import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'

// @ts-ignore
import { Link as LinkType } from '../../types/Link'
import linkStyles from '../components/DetailsLink.module.css'

interface AddItemToListCTAProps {
  keyPrefix: string
  link: LinkType
}

export default function AddItemToListCTA ({
  keyPrefix,
  link
}: AddItemToListCTAProps) {
  return (
    <AddRecordLink link={link}>
      <FormattedMessage id={`${keyPrefix}.add-item-link`} />
    </AddRecordLink>
  )
}

type AddRecordLinkProps = {
  link: LinkType
  children: React.ReactNode
}
export function AddRecordLink ({ link, children }: AddRecordLinkProps) {
  return (
    <Link href={link.href} as={link.as}>
      <a
        className={linkStyles.root}
        data-qa='add-item-link'
        data-type='tertiary'
      >
        {children}
      </a>
    </Link>
  )
}
